export const CORE_FLIGHTS_REBOOK_NAME = "core-flights-rebook";

export enum CoreFlightsRebookComponent {
  RebookFlightSegment = "RebookFlightSegment",
  RebookFlightSlice = "RebookFlightSlice",
  RebookImportantInfo = "RebookImportantInfo",
  RebookSegmentSelection = "RebookSegmentSelection",
  RebookSliceHeader = "RebookSliceHeader",
  RebookSliceOrigin = "RebookSliceOrigin",
  RebookSummaryContent = "RebookSummaryContent",
  RebookSummaryHeader = "RebookSummaryHeader",
  RebookSummaryPage = "RebookSummaryPage",
  RebookLoadingScreen = "RebookLoadingScreen",
  RebookConfirmationPage = "RebookConfirmationPage",
  RebookErrorModal = "RebookErrorModal",
  RebookReviewPage = "RebookReviewPage",
  RebookReviewFlightHeader = "RebookReviewFlightHeader",
}
